<div class="full" style="margin:5em;" *ngIf="OriginalIncident && NewIncidentRecord">
  <mat-card>
    <mat-card-content>
      <app-review-incident-modification [IncidentID]="IncidentID" [BatchID]="BatchID" [OldIncident]="OriginalIncident" [NewIncident]="NewIncidentRecord" *ngIf="NewIncidentRecord && OriginalIncident"></app-review-incident-modification>
    </mat-card-content>
  </mat-card>
</div>


